import { AUDIT_ACTIONS } from "@opus-dt/shared-types";

export type { AuditEntry, AuditListResponse } from "@opus-dt/shared-types";

export const ENTITY_TYPES = [
  "",
  "User",
  "ProductionLine",
  "Machine",
  "Parameter",
  "Sensor",
  "Product",
  "ProductionRun",
  "Alarm",
  "Scenario",
  "Simulation",
];

// "" = Todas; demais vêm do contrato (sincronizado com o enum Prisma em compile-time)
export const ACTIONS: string[] = ["", ...AUDIT_ACTIONS];
